module.exports = __webpack_public_path__ + "img/listing-item-01.84d067c2.jpg";